import React, {useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {itControlApproachType, promiseAreas} from '../../../../../../../util/uiconstants';
import {useEngagementId} from '../../../../../../../util/customHooks';
import {getBodyMetadataSlice} from '../../../../../../../selectors/ISA315/selectors';
import {labels} from '../../../../../../../util/utils';
import {getAllItControls} from '../../../../../../../actions/ITControl/itcontrolaction';
import Fetch from '../../../../../Fetch/fetch';

function ItGcWithoutDesignEffectivenessCount({bodyId, className, onCountClick}) {
	const engagementId = useEngagementId();

	const refreshCount = useSelector((state) => getBodyMetadataSlice(state, bodyId)?.refreshItControlCounter);

	const itControlsSelector = (state, _bodyId) => getBodyMetadataSlice(state, _bodyId)?.itControlsNoDesignEffectiveness;
	const itControlIdList = useSelector((state) => itControlsSelector(state, bodyId));

	const allItControls = useSelector((state) => state.bodiesSpecial.itControls?.byId);

	const itApproachTypeIdFilter = itControlApproachType.controls;

	let itControlsCount = 0;
	const countLabel = labels.itProcessItRiskItGcWithoutDesignEffectiveness;

	if (itControlIdList && itControlIdList.length > 0 && allItControls) {
		itControlIdList.forEach((itControlId) => {
			const itCtrl = allItControls[itControlId];
			if (itCtrl?.itApproachTypeId === itApproachTypeIdFilter) {
				itControlsCount++;
			}
		});
	}

	function handleOnCountClick() {
		onCountClick && onCountClick(itControlsSelector);
	}

	const dispatch = useDispatch();

	const getItControls = useCallback(
		() =>
			dispatch(
				getAllItControls(
					engagementId,
					{
						IsUnrelated: false,
						HasDesignEffectiveness: false,
						ITApproachTypeId: itApproachTypeIdFilter
					},
					{bodyId, metadataKey: 'itControlsNoDesignEffectiveness'},
					promiseAreas.ITPROCESS_UNRELATED_ITGC_COUNT
				)
			),
		[dispatch, engagementId, refreshCount]
	);

	return (
		<StyledItGcWithoutDesignEffectivenessCount className={className}>
			<Fetch fetch={getItControls} area={promiseAreas.ITPROCESS_UNRELATED_ITGC_COUNT}>
				<React.Fragment>
					{itControlsCount > 0 && (
						<section
							onClick={handleOnCountClick}
							className={`itgc-no-design-effectiveness-count${onCountClick ? ' link' : ''}`}
						>{`${itControlsCount} ${countLabel}`}</section>
					)}
				</React.Fragment>
			</Fetch>
		</StyledItGcWithoutDesignEffectivenessCount>
	);
}

const StyledItGcWithoutDesignEffectivenessCount = styled.section`
	margin: 0 var(--px-5);
	.itgc-no-design-effectiveness-count {
		font-weight: bold;
		color: var(--red-600);
	}
	.link:hover {
		text-decoration: underline;
		cursor: pointer;
		color: var(--red-700);
	}
`;

ItGcWithoutDesignEffectivenessCount.propTypes = {
	bodyId: PropTypes.number,
	className: PropTypes.string,
	onCountClick: PropTypes.func
};

export default ItGcWithoutDesignEffectivenessCount;
